/**
 * 종목/포지션 관련 UI 문자열 리소스
 * symbol-list-view, position-list-view 등에서 사용
 */
export const marketStr = {
  error: {
    /** 종목 미선택 시 레버리지 변경 불가 */
    selectSymbolsFirst: '레버리지를 변경할 종목들을 먼저 선택해주세요.',
    /** 레버리지 범위 오류 */
    leverageRange: '레버리지는 1~100 사이의 값이어야 합니다.',
  },
  position: {
    // 버튼 및 액션
    exitAfterReverse: '청산 후 반대 포지션 진입',
    deleteBackSignal: '백시그널 삭제',
    exitAll: '모두 청산',
    reverseAll: '모두 Rev',
    exit: '청산',
    reversePosition: '반대 포지션 진입',
    // 드롭다운 메뉴
    selectedOnly: '선택한 종목만',
    longOnly: '롱만',
    shortOnly: '숏만',
    // 레이블
    winCount: '수익종목',
    lossCount: '손실종목',
    investCandidate: '투자 후보 :',
    long: '롱',
    short: '숏',
    // 요약 정보
    evalAmount: '평가액',
    entryAmountTooltip: '진입액: {amount}',
    longNetProfit: '롱순익',
    shortNetProfit: '숏순익',
    netProfit: '순익',
    // 컬럼 헤더 서브 텍스트
    subTextEntryAmount: '(진입액)',
    subTextEntryPrice: '(진입가)',
  },
  signal: {
    // 버튼 및 액션
    ignoreThisSignal: '이 신호 무시',
    enterLong: '롱 진입',
    enterShort: '숏 진입',
    enterLongOnly: '롱만 진입',
    enterShortOnly: '숏만 진입',
    enterAll: '모두 진입',
    ignoreAllSignals: '현재 신호 모두 무시',
    // 헷지진입
    enterHedge: '헷지진입',
    enterHedgeFailed: '헷지진입 실패: 롱·숏 모두 주문에 실패했습니다.',
    enterHedgePartialFailed: '헷지진입 일부 실패: 한 방향 주문에 실패했습니다.',
    enterHedgeConflict: '헷지진입 불가: 이미 오더라인이 존재합니다.',
    // 컨텍스트 메뉴
    enterBySignal: '신호 진입',
  },
  timeframe: {
    search: '검색',
    rising: '상승',
    falling: '하락',
  },
  symbolList: {
    // 검색
    searchPlaceholder: '종목 검색...',
    // PillLabel
    undecided: '미정',
    // Select
    leverage: '레버리지',
    // 버튼
    addInvestCandidate: '+ 투자 후보',
    removeInvestCandidate: '- 투자 후보',
    enterLong: '롱 진입',
    enterShort: '숏 진입',
    enterLongOnly: '롱만 진입',
    enterShortOnly: '숏만 진입',
    enterAll: '모두 진입',
    removeAll: '모두 제거',
    // 검색 옵션
    trendNone: '없음',
    // 컨텍스트 메뉴
    enterBySignal: '신호 진입',
    addToInvestList: '투자 후보 추가',
    removeFromInvestList: '투자 후보 제거',
  },
  searchBox: {
    // Select 플레이스홀더
    selectPreset: '조건식 선택',
    // 버튼
    search: '검색',
    save: '저장',
    delete: '삭제',
    close: '닫기',
    addCondition: '+ 조건',
    // Input 플레이스홀더
    presetName: '조건식 분류명',
    note: '비고',
    searchPlaceholder: '검색',
    // 타이틀
    addConditionTitle: '조건 추가',
    deleteConditionTitle: '조건 삭제',
    // 에러 메시지
    enterPresetName: '조건식 분류명을 입력해주세요.',
  },
  correlation: {
    // 버튼 및 레이블
    calculateButton: '상관계수 계산',
    calculating: '상관계수를 계산하고 있습니다. 잠시 기다려 주세요...',
    cancelButton: '중지',
    // 모달
    modalTitle: '{timeframe} 캔들 상관계수 계산',
    baseAsset: '기준 자산',
    baseAssetHelp: '선택된 {count}개 종목과 비교합니다',
    baseAssetPlaceholder: '전체 종목 중 기준 자산 선택',
    baseAssetRequired: '기준 자산을 선택해주세요.',
    priceType: '가격 타입',
    priceTypeRequired: '가격 타입을 선택해주세요.',
    priceTypeOpenClose: '시가 - 종가',
    priceTypeLowHigh: '저가 - 고가',
    valueType: '값 타입',
    valueTypeRequired: '값 타입을 선택해주세요.',
    valueTypePrice: '가격',
    valueTypePercentage: '가격 변동률',
    calculationPeriodStart: '계산 기간 (시작)',
    calculationPeriodEnd: '계산 기간 (종료)',
    startTimeRequired: '시작 시간을 선택해주세요.',
    endTimeRequired: '종료 시간을 선택해주세요.',
    candleCount: '상관계수 계산 캔들수',
    candleCountHelp: '선택한 기간을 {timeframe} 봉 기준으로 자동 계산합니다.',
    candleCountHelpWithLimit: '선택한 기간을 {timeframe} 봉 기준으로 자동 계산합니다. (최대 {limit}개)',
    candleCountHelpNoTimeframe: '봉 타임프레임이 선택되어 있지 않습니다.',
    candleCountUnit: '개',
    calculateAction: '계산',
    cancelAction: '취소',
    // 툴팁
    tooltipPriceType: '가격 타입',
    tooltipValueType: '값 타입',
    tooltipPeriod: '기간',
    tooltipLastCalculated: '마지막 계산',
    // 메시지
    selectAtLeastOne: '1개 이상의 종목을 선택해주세요.',
    endTimeMustBeAfterStart: '종료 시간은 시작 시간보다 늦어야 합니다.',
    candleCountExceeded: '상관계수 계산 캔들 수가 최대치({limit}개)를 초과하여 기간을 자동으로 조정했습니다.',
    calculationComplete: '상관계수 계산 완료: {count}개 종목 ({seconds}초)',
    calculationCanceled: '상관계수 계산이 취소되었습니다.',
    loadingExchangeConfig: '거래소 설정을 불러오는 중입니다. 잠시 후 다시 시도해주세요.',
  },
  modal: {
    selectSymbol: '종목 선택',
  },
};
